export enum UserFeedConnectionTabSearchParam {
  Message = "?view=message",
  Filters = "?view=filters",
  RateLimits = "?view=rate-limits",
  CustomPlaceholders = "?view=custom-placeholders",
}
